export const rateUpdateDelay = 600;
